import React from 'react'
import "./SubStyle.css"

const Soft_Audit = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">Care Audit Software</h1>
      <p className="OurServices-pera">Enhance quality assurance through a streamlined auditing process. Our Care Audit Software enables providers to conduct inspections, track findings, monitor improvements, and maintain accurate records that support continuous service excellence.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_Audit
